export default __webpack_public_path__ + "static/media/ticket-color.9c46ec51.svg";